import { render, staticRenderFns } from "./InformedConsentForTherapy.vue?vue&type=template&id=5c554ad6"
import script from "./InformedConsentForTherapy.vue?vue&type=script&lang=js"
export * from "./InformedConsentForTherapy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports